import React from 'react';
import PropTypes from 'prop-types';
import TwitterIcon from 'components/Common/Icons/TwitterIcon';
import Skeleton from '../../Skeleton/Skeleton';
import './TileHeader.scss';
import Tooltip from '../../Tooltip/Tooltip';
import trans from '../../../../services/translate/translate';
import NetworkIcon from '../../NetworkIcon/NetworkIcon';

const MockChildren = () => (
  <>
    <TwitterIcon />
    <span>twitter</span>
  </>
);

const TileHeader = ({ color, loading, name, twitterHandle, profileImg, statusObject, chainId }) => {
  const { tooltipTitle, tooltipText } = statusObject;
  return (
    <Skeleton className="pool-tile-header">
      <div className="pool-tile-header-profile">
        <Skeleton loading={loading} className="photo">
          <img src={profileImg} alt={name} />
        </Skeleton>
        <div>
          <Skeleton loading={loading} className="name" mockChildren={<span>This is</span>}>
            <div>{name}</div>
          </Skeleton>
          <Skeleton loading={loading} className="twitter-handle" mockChildren={<MockChildren />}>
            <div className="twitter-handle">
              <TwitterIcon />
              <span>{twitterHandle}</span>
            </div>
          </Skeleton>
        </div>
      </div>
      <div className="pool-tile-header-status d-flex gap-md align-center">
        <NetworkIcon chainId={loading ? '' : chainId || 3} />
        <Tooltip
          show={!loading}
          className="pool-tile-header-tooltip"
          title={tooltipTitle && trans(tooltipTitle)}
          text={tooltipText && trans(tooltipText)}
        >
          <span className="circle" style={{ background: color }}>
            &nbsp;
          </span>
        </Tooltip>
      </div>
    </Skeleton>
  );
};

TileHeader.defaultProps = {
  name: null,
  twitterHandle: null,
  profileImg: null,
};

TileHeader.propTypes = {
  name: PropTypes.string,
  twitterHandle: PropTypes.string,
  profileImg: PropTypes.string,
  color: PropTypes.string.isRequired,
  chainId: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  statusObject: PropTypes.object.isRequired,
};

export default TileHeader;
